"use strict";

exports.__esModule = true;

var Timer =
/** @class */
function () {
  function Timer() {}

  Timer.start = function (name) {
    Timer.timers[name] = Date.now();
  };

  Timer.finish = function (name) {
    var startPoint = Timer.timers[name];
    delete Timer.timers[name];
    return Date.now() - startPoint;
  };

  Timer.timers = {};
  return Timer;
}();

exports.Timer = Timer;